import React from "react";

interface Props {
  onChange: (val?: number) => void;
  value: number;
}

const MoneyInput: React.FunctionComponent<Props> = ({
  onChange,
  value,
}: Props) => {
  return (
    <input
      type="number"
      value={value}
      className="block w-full rounded-md border-0 py-1.5 pl-7 pr-12 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
      placeholder="0.00"
      onChange={(event) => {
        if (event.target.value) {
          const afterDecimal = event.target.value.split(".")?.[1];

          if (afterDecimal && afterDecimal.length > 2) return;

          onChange(Number(event.target.value));
        } else {
          // backspace
          onChange(undefined);
        }
      }}
    />
  );
};

export default MoneyInput;
